import React, { useEffect } from 'react';
import { Button, Card, Form, Select, Space } from 'antd';
import { useForm } from "antd/es/form/Form";
import StoreSettingService from "services/store_setting";
import { useApp } from 'contexts/app';

const service = new StoreSettingService();

const triggerTypeOptions = [
    { value: "shipping_status", label: "Theo trạng thái vận chuyển" },
    { value: "internal_status", label: "Theo trạng thái nội bộ" }
];

const triggerValueOptionsByType = {
    shipping_status: [
        { value: "not_shipped", label: "Chưa vận chuyển" },
        { value: "shipping", label: "Đang vận chuyển" },
        { value: "shipped", label: "Đã giao" },
    ],
    internal_status: [
        { value: "pending", label: "Chờ xử lý" },
        { value: "packing", label: "Đang chuẩn bị" },
    ]
};

const WarehouseSettingPage = () => {
    const [form] = useForm();
    const { showLoading, showNotify } = useApp();
    const triggerType = Form.useWatch("trigger_type", form);
    const [internalStatusOptions, setInternalStatusOptions] = React.useState(triggerValueOptionsByType.internal_status);

    useEffect(() => {
        loadData();
    }, []);

    const getCurrentTriggerValueOptions = (type) => {
        if (type === "internal_status") {
            return internalStatusOptions;
        }
        return triggerValueOptionsByType[type] ?? triggerValueOptionsByType.shipping_status;
    };

    const loadData = async () => {
        const statuses = await service.getOrderInternalStatuses();
        const mappedStatuses = (statuses ?? []).map(x => ({ value: x.id, label: x.title }));
        if (mappedStatuses.length > 0) {
            setInternalStatusOptions(mappedStatuses);
        }

        const setting = await service.getInventoryDeductionSetting();
        const trigger_type = setting?.trigger_type || "shipping_status";
        const triggerValues = getCurrentTriggerValueOptions(trigger_type);
        const trigger_value = setting?.trigger_value || triggerValues[0]?.value;
        form.setFieldsValue({ trigger_type, trigger_value });
    }

    const onFinish = async (values) => {
        showLoading(true);
        await service.saveInventoryDeductionSetting(values);
        await loadData();
        showLoading(false);
        showNotify("Đã cập nhật");
    };

    const onValuesChange = (changedValues, allValues) => {
        if (changedValues.trigger_type) {
            const options = getCurrentTriggerValueOptions(changedValues.trigger_type);
            const exists = options.find(x => x.value === allValues.trigger_value);
            if (!exists) {
                form.setFieldValue("trigger_value", options[0]?.value);
            }
        }
    }

    const currentTriggerValueOptions = getCurrentTriggerValueOptions(triggerType || "shipping_status");

    return (
        <Card title="Cấu hình kho - xuất kho đơn hàng">
            <Form
                form={form}
                name="warehouse_setting"
                layout='vertical'
                initialValues={{
                    trigger_type: "shipping_status",
                    trigger_value: "shipped"
                }}
                onFinish={onFinish}
                onValuesChange={onValuesChange}
                autoComplete="off"
            >
                <Form.Item
                    label="Kiểu điều kiện xuất kho"
                    name="trigger_type"
                    rules={[{ required: true }]}
                >
                    <Select options={triggerTypeOptions} />
                </Form.Item>

                <Form.Item
                    label="Giá trị trạng thái để xuất kho"
                    name="trigger_value"
                    rules={[{ required: true }]}
                >
                    <Select options={currentTriggerValueOptions} />
                </Form.Item>

                <Form.Item label="Diễn giải">
                    <Space direction="vertical" size={2}>
                        <div>
                            Hệ thống sẽ trừ tồn kho (ship) khi đơn hàng đạt đúng trạng thái đã chọn.
                        </div>
               
                    </Space>
                </Form.Item>

                <Form.Item>
                    <Button type="primary" htmlType="submit">
                        Cập nhật
                    </Button>
                </Form.Item>
            </Form>
        </Card>
    )
}

export default WarehouseSettingPage;